export const parseCookies = () =>
  document.cookie
    .split(';')
    .find(t => t.indexOf('session=') !== -1 && t.indexOf('auth_session') === -1)
    ?.replace('session=', '') || '';
